import { Modal } from './Modal.js';

interface ConfirmOptions {
    title?: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
}


export function confirmDialog({
    title = 'Confirm',
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
}: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
        let answered = false;
        const settle = (value: boolean): void => {
            if (answered) return;
            answered = true;
            resolve(value);
        };
        const modal = new Modal({
            title,
            variant: 'confirm',
            onClose: () => settle(false),
        });

        const text = document.createElement('p');
        text.className = 'confirm-message';
        text.textContent = message;

        const actions = document.createElement('div');
        actions.className = 'confirm-actions';

        const cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'confirm-cancel';
        cancel.textContent = cancelLabel;
        cancel.addEventListener('click', () => {
            settle(false);
            modal.close();
        });

        const confirm = document.createElement('button');
        confirm.type = 'button';
        confirm.className = 'confirm-accept';
        confirm.textContent = confirmLabel;
        confirm.addEventListener('click', () => {
            settle(true);
            modal.close();
        });

        actions.appendChild(cancel);
        actions.appendChild(confirm);

        const body = document.createElement('div');
        body.className = 'confirm-body';
        body.appendChild(text);
        body.appendChild(actions);
        modal.body.appendChild(body);

        modal.open();
        confirm.focus();
    });
}
